module.exports = __webpack_public_path__ + "media/pro/amazon-pay@2x-19cf9d4c.png";